import { useQuery } from '@tanstack/react-query'

import { getAuthSessionInfo } from '~/generated/client'

/**
 * Deprecated: Use useUser instead
 */
export const useGetUserInfo = () => {
  const {
    data: authSessionInfo,
    isLoading,
    isError,
    isSuccess,
  } = useQuery({
    queryKey: ['clientInfo'],
    queryFn: getAuthSessionInfo,
    retry: 3,
    refetchOnMount: true,
    staleTime: Infinity,
  })
  return {
    authSessionInfo,
    isLoading,
    isError,
    isSuccess,
  }
}
